<template>
    <div @mousemove="mouseMove" @mouseup="mouseUp" @mouseout="mouseOut" ref="content_refs">
        <VideoRef v-if="renderComponent" :clientX="clientX" :mouseUpStatus="mouseUpStatus" />

        <div id="content" v-if="videoRefLoaded">
            <div class="container">
                <div id="filters" class="row">
                    <button type="button" id="btn-reset" @click="resetFilters()" v-if="this.$store.state.app.filter">{{ $t("message.see_all_references") }}</button>
                    <!--<select name="metier" v-model="this.$store.state.app.filterMetier">
                    <option value="">{{ $t("message.filter_metier") }}</option>
                    <option v-for="(item, index) in this.$store.state.app.filters.metier[local]" :value="item" :key="index">{{ item }}</option>
                </select>

                <select name="sujet" v-model="this.$store.state.app.filterSujet">
                    <option value="">{{ $t("message.filter_sujet") }}</option>
                    <option v-for="(item, index) in this.$store.state.app.filters.sujet[local]" :value="item" :key="index">{{ item }}</option>
                </select>

                <select name="dispositif" v-model="this.$store.state.app.filterDispositif">
                    <option value="">{{ $t("message.filter_dispositif") }}</option>
                    <option v-for="(item, index) in this.$store.state.app.filters.dispositif[local]" :value="item" :key="index">{{ item }}</option>
                </select>-->
                </div>

                <div id="refs">
                    <div v-for="(r, index) in references" :key="index" :data-tags="r.tags.join(' ')">
                        <div>
                            <div class="media" @click="displayRef(r.id)">
                                <img :src="'./refs/' + r.promote" alt="" />
                            </div>
                            <div class="title" @click="displayRef(r.id)">
                                <Play />
                                <span v-html="truncate(r.title, 70)"></span>
                            </div>
                            <div class="desc" @click="displayRef(r.id)">
                                <div v-html="truncate(r.content.replace(/<[^>]+>/g, ''), 150)"></div>
                                <span>{{ $t("message.see") }}</span>
                            </div>
                            <div class="tags">
                                <span v-for="(t, idx) in r.tags" :key="idx" @click="runFilter(t, this.$store.state.app.filter === t ? true : false)" :class="this.$store.state.app.filter === t ? 'active' : ''">
                                    {{ t }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Contact />
    </div>
</template>

<script>
import { nextTick, ref } from "vue";
const renderComponent = ref(true);

import VideoRef from "../components/VideoRef.vue";
import Play from "../components/img/Play.vue";
import Modal from "../components/Modal.vue";
import Contact from "../components/Contact.vue";

export default {
    name: "References",
    data() {
        return {
            local: "fr",
            showModal: false,
            indexRef: 0,
            isMobile: false,
            renderComponent: true,
            videoRefLoaded: false,
            clientX: 0,
            mouseUpStatus: false,

            tag: null,

            tagMetier: null,
            tagSujet: null,
            tagDispositif: null,
        };
    },
    components: {
        Play,
        Modal,
        Contact,
        VideoRef,
    },
    computed: {
        references: function () {
            return this.$store.getters["app/getRefs"](this.local).filter((i) => {
                let valid = true;
                if (this.$store.state.app.filter && i.tags.indexOf(this.$store.state.app.filter) == -1) valid = false;
                return valid;
            });
        },
    },
    watch: {
        "$i18n.locale": function (locale) {
            this.local = locale;
            this.forceRerender();
        },
        "$store.state.app.videoRefLoaded": {
            handler(videoRefLoaded) {
                if (videoRefLoaded) {
                    this.videoRefLoaded = videoRefLoaded;
                    this.$store.dispatch("app/setVideoRefLoaded", false);
                }
            },
        },
    },
    beforeMount() {
        let storedTags = localStorage.getItem("tags");
        if (storedTags) {
            storedTags = JSON.parse(storedTags);
            if (Array.isArray(storedTags)) {
                storedTags.forEach((tag, index) => {
                    if (tag) this.runFilter(tag, false);
                });
            }
        }
        localStorage.removeItem("tags");
    },
    created() {
        let _this = this;
        /**
         * Ajout class si version mobile
         */
        window.addEventListener("resize", function (e) {
            _this.isItMobile();
        });
        this.isItMobile();

        window.addEventListener("scroll", this.handleScroll);
    },
    mounted() {
        this.local = this.$i18n.locale;

        // Si il y a un ID reference dans l'url, on affiche la modal
        const params = new URLSearchParams(window.location.search);
        const idRef = params.get("ref");
        if (idRef) this.displayRef(idRef);
    },
    methods: {
        async forceRerender() {
            this.renderComponent = false;
            await nextTick();
            this.renderComponent = true;
        },
        mouseMove(e) {
            this.clientX = e.clientX;
        },
        mouseUp() {
            this.mouseUpStatus = !this.mouseUpStatus;
        },
        mouseOut(e) {
            let content_refs = this.$refs["content_refs"];
            if (!content_refs.contains(e.relatedTarget)) this.mouseUpStatus = !this.mouseUpStatus;
        },
        isItMobile() {
            let windowWidth = window.innerWidth;

            if (windowWidth < 992 && !this.isMobile) this.forceRerender();
            else if (windowWidth >= 992 && this.isMobile) this.forceRerender();

            this.isMobile = windowWidth < 992 ? true : false;
        },
        truncate(str, maxlength) {
            return str.length > maxlength ? str.slice(0, maxlength - 1) + "…" : str;
        },
        displayRef(idx) {

            this.$store.dispatch("app/displayModal", {
                display: true,
                name: "reference",
                content: this.$store.getters["app/getRef"](this.local, idx),
                index: idx,
                //content: this.$store.state.app.refs[this.local][idx],
            });
        },
        resetFilters() {
            this.$store.dispatch("app/setFilter", "");
        },
        runFilter(tag, status) {
            for (let i = 0; i < this.$store.state.app.filters[this.local].length; i++) {
                let filter = this.$store.state.app.filters[this.local][i];
                if (tag === filter) {
                    this.$store.dispatch("app/setFilter", status ? "" : tag);
                }
            }

            const el = document.getElementById("content");
            if (el) {
                const y = el.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#content {
    position: relative;
    padding-top: 60px;
}

#filters {
    margin: 0 auto;
    max-width: 1400px;
    width: 100%;
    justify-content: center;
    display: flex;
    height: 5rem;
    align-items: center;
}

#filters select {
    background: #fff;
    color: #ff0000;
    font-weight: 700;
    border: 0;
    border-radius: 10px;
    padding: 0.5rem;
    font-size: 1.2rem;
    margin-right: 2rem;
    outline: none;
}

#btn-reset {
    background-color: #0e3077;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.6rem 1rem;
    font-size: 1.2rem;
    border-radius: 15px;
    border: 0;
    cursor: pointer;
}

.splide img {
    width: 100%;
    margin: auto;
    display: block;
}

#refs {
    display: flex;
    flex-flow: row wrap;
    align-items: stretch;
    justify-content: space-between;
    margin: 0 auto 8rem;
    max-width: 1400px;
    width: 100%;

    &::after {
        content: "";
        flex: 0 0 30%;
    }

    > div {
        width: 30%;
        display: flex;
        flex-flow: column;
        margin-bottom: 3rem;
        cursor: pointer;
        transition: all 0.3s;

        > div {
            overflow: hidden;
            border-radius: 15px;
            height: 100%;
            display: flex;
            flex-flow: column;
            background: rgba(255, 255, 255, 0.5);
            box-shadow: 0px 0px 34px 10px rgba(0, 0, 0, 0.3);
        }

        > a {
            color: #707070;
            text-decoration: none;
            align-self: flex-end;
            margin-top: 1rem;
            font-size: 1.4rem;
            transition: all 0.4s;

            &:hover,
            &:focus {
                color: #ff0000;
            }
        }

        &:hover {
            transform: scale(1.05);
            z-index: 1;
        }
    }
}

.title {
    font-family: Oswald, sans-serif;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    box-sizing: border-box;
    height: 86px;

    svg {
        margin-right: 0.8rem;
        flex: 0 0 24px;
    }
}

.desc {
    font-size: 1.2rem;
    padding: 0 1rem;
    box-sizing: border-box;
    font-family: "Roboto", sans-serif;
    font-weight: 300;
    flex: 1;

    span {
        margin-top: 0.5rem;
        color: #969696;
        cursor: pointer;
        display: inline-block;
        font-weight: normal;
        transition: all 0.4s;

        &:hover,
        &:focus {
            color: #ff0000;
        }
    }
}

.media {
    width: 100%;
    aspect-ratio: 16/9;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 100%;
    }
}

.tags {
    color: #0093ff;
    padding: 1rem;
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;
    font-size: 1rem;
    flex-flow: row wrap;

    span {
        margin-right: 0.6rem;
        transition: all 0.3s;
        margin-right: 0.6rem;
        cursor: pointer;
        transition: all 0.3s;
        background-color: #0e3077;
        border: 1px solid #0e3077;
        color: #fff;
        display: inline-block;
        padding: 0.5rem;
        border-radius: 5px;
        margin-top: 0.5rem;

        &:hover {
            color: #ff0000;
        }

        &.active {
            background-color: #fff;
            color: #0e3077;
        }
    }
}

@media (max-width: 1400px) {
    #refs {
        margin: 0 0 2rem;

        &::after {
            content: "";
            flex: 0 0 30%;
        }

        > div {
            width: 30%;
            margin-bottom: 3rem;

            > a {
                margin-top: 1rem;
                font-size: 1.4rem;
            }
        }
    }

    .title {
        font-size: 1.2rem;
        height: 78px;

        svg {
            margin-right: 0.8rem;
            flex: 0 0 20px;
        }
    }

    .desc {
        font-size: 1rem;
        padding: 1rem;
        box-sizing: border-box;
    }

    .tags {
        font-size: 1rem;
    }
}

@media (max-width: 1200px) {
    #refs {
        //margin: 2rem 0;
        justify-content: space-around;

        &::after {
            content: "";
            flex: 0 0 40%;
        }

        > div {
            width: 40%;
            margin-bottom: 3rem;

            > a {
                margin-top: 1rem;
                font-size: 1.4rem;
            }
        }
    }

    .title {
        font-size: 1.2rem;

        svg {
            margin-right: 0.8rem;
            flex: 0 0 20px;
        }
    }

    .desc {
        font-size: 1rem;
        padding: 1rem;
        box-sizing: border-box;
    }
}

@media (max-width: 992px) {
    #refs {
        //margin: 2rem 0;
        justify-content: space-between;

        &::after {
            content: "";
            flex: 0 0 40%;
        }

        > div {
            width: 48%;
            margin-bottom: 3rem;

            > a {
                margin-top: 1rem;
                font-size: 1.4rem;
            }
        }
    }

    .title {
        font-size: 1.2rem;

        svg {
            margin-right: 0.8rem;
            flex: 0 0 20px;
        }
    }

    .desc {
        font-size: 1rem;
        padding: 1rem;
        box-sizing: border-box;
    }
}

@media (max-width: 768px) {
    #refs {
        //margin: 2rem 0;
        justify-content: space-between;

        &::after {
            content: "";
            flex: 0 0 40%;
        }

        > div {
            width: 100%;
            max-width: 500px;
            margin: auto;
            margin-bottom: 2rem;

            > a {
                margin-top: 1rem;
                font-size: 1.4rem;
            }

            &:hover {
                transform: scale(1.02);
            }
        }
    }

    .title {
        font-size: 1.2rem;

        svg {
            margin-right: 0.8rem;
            flex: 0 0 20px;
        }
    }

    .desc {
        font-size: 1rem;
        padding: 1rem;
        box-sizing: border-box;
    }
}

@media (max-width: 655px) {
    #refs {
        > div {
            width: 100%;
            max-width: 100%;
        }
    }

    /*#filters {
        margin-top: 2rem;
        display: flex;
        flex-flow: column;

        select {
            margin-bottom: 1rem;
        }
    }*/
}

@media (max-width: 576px) {
    #refs {
        //margin: 2rem 0;
        justify-content: space-between;

        &::after {
            content: "";
            flex: 0 0 40%;
        }

        > div {
            width: 100%;
            margin: auto;
            margin-bottom: 1rem;

            > a {
                margin-top: 1rem;
                font-size: 1.4rem;
            }
        }
    }

    .title {
        font-size: 1.2rem;

        svg {
            margin-right: 0.8rem;
            flex: 0 0 20px;
        }
    }

    .desc {
        font-size: 1rem;
        padding: 1rem;
    }
}
</style>
